import { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { cn } from "utils";

const GeographicalRegion = ({
  geographicalRegions,
  searchState,
  setGeographicalRegions,
  itemsLimit,
}) => {
  const [expanded, setExpanded] = useState(false);

  const finalItems = useMemo(() => {
    if (expanded && geographicalRegions.length > itemsLimit) {
      return geographicalRegions;
    }

    return geographicalRegions.slice(0, itemsLimit);
  }, [expanded, itemsLimit, geographicalRegions]);

  const handleGeographicalPreset = (regionName) => {
    let unCheckedCountries = [];

    const geographicalRegion = geographicalRegions.map((geoRegion) => {
      if (geoRegion.regionName === regionName) {
        if (geoRegion.checked) {
          // This region is about to get unchecked
          // Mark all countries under it as to-be unchecked
          unCheckedCountries = unCheckedCountries.concat(
            geoRegion.countryNames
          );
        }

        return {
          ...geoRegion,
          checked: !geoRegion.checked,
        };
      }

      return geoRegion;
    });

    setGeographicalRegions(geographicalRegion, true, [], unCheckedCountries);
  };

  useEffect(() => {
    if (geographicalRegions.some((geoRegion) => geoRegion.checked)) {
      const { refinementList } = searchState;

      const searchLocations = refinementList?.["location.countryName"];

      const regionToUnMark = geographicalRegions.find((geoRegion) => {
        return (
          geoRegion.checked &&
          !geoRegion.countryNames.some((region) =>
            searchLocations?.includes(region)
          )
        );
      });
      if (regionToUnMark) {
        handleGeographicalPreset(regionToUnMark.regionName);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState.refinementList?.["location.countryName"]]);

  return (
    <>
      <ul className="ais-RefinementList-list">
        {finalItems.map((geoRegion) => (
          <li
            key={geoRegion.regionName}
            className={cn("mt-1 ais-RefinementList-item", {
              "ais-RefinementList-item--selected": geoRegion.checked,
            })}
          >
            <label
              className="flex items-center text-sm whitespace-nowrap ais-RefinementList-label"
              title={geoRegion.countryNames?.join(", ")}
            >
              <input
                type="checkbox"
                className="ais-RefinementList-checkbox"
                checked={geoRegion.checked || false}
                onChange={() => handleGeographicalPreset(geoRegion.regionName)}
              />
              <span
                className={cn("mx-2 overflow-hidden text-ellipsis", {
                  "font-bold": geoRegion.checked,
                })}
              >
                {geoRegion.regionName}
              </span>
            </label>
          </li>
        ))}
      </ul>
      {geographicalRegions.length > itemsLimit && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="ais-RefinementList-showMore"
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </>
  );
};

GeographicalRegion.propTypes = {
  geographicalRegions: PropTypes.array,
  itemsLimit: PropTypes.number,
};

GeographicalRegion.defaultProps = {
  geographicalRegions: [],
  itemsLimit: 10,
};

export default GeographicalRegion;
